import { Icon } from '@/components/icons/Icon'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type RecType } from '@/defs/rec'
import { cn } from '@/utils/commonUtil'
import { formatFullNumber } from '@/utils/formatUtil'
import { getRecName } from '@/utils/recUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'

import styles from './StatRecRank.module.scss'

type Props = {
  rec: RecType
}

export const StatRecRank = ({ rec }: Props) => {
  const { rank } = rec
  const fullName = getRecName(rec)

  let variant
  if (rank !== undefined) {
    if (rank <= 3) variant = 'top3'
    else if (rank <= 10) variant = 'top10'
    else if (rank <= 50) variant = 'top50'
    else if (rank <= 100) variant = 'top100'
  }

  const popover = rank !== undefined && (
    <>
      <h2>
        <IconWithLabel iconBefore='chessKing'>Rank</IconWithLabel>
      </h2>
      <p>
        <strong>{fullName}</strong> is ranked <strong>#{formatFullNumber(rank)}</strong> in popularity among all
        commanders.
      </p>
    </>
  )

  return (
    <StatCommonBox label='Rank' popover={popover}>
      {rank !== undefined && (
        <span className={cn(styles.container, { styles, variant })}>
          {!!variant && (
            <span className={styles.icon}>
              <Icon name='star' />
            </span>
          )}
          <span className={styles.figure}>
            <span className={styles.numberSign}>#</span>
            <span className={styles.rank}>{formatFullNumber(rank)}</span>
          </span>
        </span>
      )}
    </StatCommonBox>
  )
}
